"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JVMAPI = void 0;
const api_1 = require("../api");
const Service = 'jvm';
const VMEndpoint = '/vm/jvm';
class JVMAPI extends api_1.AbstractUtxoAPI {
    chain;
    constructor(client, chain) {
        super(client, `/ext/bc/${chain.id}`, Service);
        this.chain = chain;
    }
    async buildGenesis(networkID, genesisData, encoding) {
        const response = await this.callAt(VMEndpoint, 'buildGenesis', [
            { networkID, genesisData, encoding }
        ]);
        return response.result;
    }
    async getAssetDescription(assetID) {
        const response = await this.call('getAssetDescription', [{ assetID }]);
        return response.result;
    }
    async getBlock(blockID, encoding) {
        const response = await this.call('getBlock', [{ blockID, encoding }]);
        return response.result;
    }
    async getBlockByHeight(height, encoding) {
        const response = await this.call('getBlockByHeight', [{ height, encoding }]);
        return response.result;
    }
    async getHeight() {
        const response = await this.call('getHeight');
        return response.result;
    }
}
exports.JVMAPI = JVMAPI;
